export default __webpack_public_path__ + "static/media/SKOCZNOSC.e6f0f501.png";